import { render, staticRenderFns } from "./ConfirmDeleteProduct.vue?vue&type=template&id=3624b90b"
import script from "./ConfirmDeleteProduct.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports